import { Injectable } from '@angular/core';
import { PublisherCampaignAllocation, CampaignPpa, Campaign } from '../../campaigns/campaign.model';

@Injectable()
export class ObjectFactoryService {

    public createPublisherAllocation(id: number, campaignId: number, publisherId: number, endUtc: Date, startUtc: Date, isAvailable: boolean,
        publisherCpe: number, totalAllocatedViews: number, totalAllocatedViewsPerDay: number, totalRequestsPerUserPerDay: number)
        : PublisherCampaignAllocation {
        let publisherCampaignAllocation = new PublisherCampaignAllocation();
        publisherCampaignAllocation.id = id;
        publisherCampaignAllocation.campaignId = campaignId;
        publisherCampaignAllocation.endUtc = endUtc;
        publisherCampaignAllocation.isAvailable = isAvailable;
        publisherCampaignAllocation.publisherCpe = publisherCpe;
        publisherCampaignAllocation.publisherId = publisherId
        publisherCampaignAllocation.startUtc = startUtc;
        publisherCampaignAllocation.totalAllocatedViews = totalAllocatedViews;
        publisherCampaignAllocation.totalAllocatedViewsPerDay = totalAllocatedViewsPerDay;
        publisherCampaignAllocation.totalRequestsPerUserPerDay = totalRequestsPerUserPerDay;
        return publisherCampaignAllocation;
    }

    public createPPA(id: number, campaignId: number, ppaType: number, ppaTypeName: string, order: number,
        displayProbability: number, isLive: boolean, clickThroughUrl: string, facebookShareUrl: string, twitterShareUrl: string)
        : CampaignPpa {
        let campaignPpa = new CampaignPpa();
        campaignPpa.campaignId = campaignId;
        campaignPpa.displayProbability = displayProbability;
        campaignPpa.id = id;
        campaignPpa.isLive = isLive;
        campaignPpa.order = order;
        campaignPpa.ppaType = ppaType;
        campaignPpa.ppaTypeName = ppaTypeName;
        campaignPpa.clickThroughUrl = clickThroughUrl;
        campaignPpa.facebookShareUrl = facebookShareUrl;
        campaignPpa.twitterShareUrl = twitterShareUrl;
        return campaignPpa;
    }

    public createCampaign(id: number, embedCode: string, hasCompanion: boolean, brand: string, product: string, totalAllocatedViews: number,
        totalAllocatedViewsPerDay: number, totalAllocatedViewsPerUser: number, minAge: number, maxAge: number, countryId: number,
        providerId: number, startDateUtc: Date, endDateUtc: Date, isAndroid: boolean, isMale: boolean, isAvailable: boolean,
        is18PlusContent: boolean, isGridContentType: boolean, isAdvertisingIdRequired: boolean, floorPrice: number, value: number,
        dsp: string, ssp: string, tradingDesk: string, brandLogoId?: number, isServerSide: boolean = false,
        isPrePaidConsumer: boolean = false, isPostPaidConsumer: boolean = false, isPostPaidCorporate: boolean = false)
        : Campaign {
        let campaign: Campaign = new Campaign();
        campaign.id = id;
        campaign.brand = brand;
        campaign.product = product;
        campaign.dsp = dsp;
        campaign.ssp = ssp;
        campaign.tradingDesk = tradingDesk;
        campaign.minAge = minAge;
        campaign.maxAge = maxAge;
        campaign.embedCode = embedCode;
        campaign.hasCompanion = hasCompanion;
        campaign.totalAllocatedViewsPerUser = totalAllocatedViewsPerUser;
        campaign.totalAllocatedViewsPerDay = totalAllocatedViewsPerDay;
        campaign.totalAllocatedViews = totalAllocatedViews;
        campaign.isAvailable = isAvailable;
        campaign.is18PlusContent = is18PlusContent;
        campaign.isAdvertisingIdRequired = isAdvertisingIdRequired;
        campaign.floorPrice = floorPrice;
        campaign.value = value;
        campaign.brandLogoId = brandLogoId;
        campaign.startDateUtc = startDateUtc;
        campaign.endDateUtc = endDateUtc;
        campaign.countryId = countryId;
        campaign.providerId = providerId;
        campaign.isAndroid = isAndroid;
        campaign.isMale = isMale;
        campaign.isGridContentType = isGridContentType;
        campaign.isServerSide = isServerSide;
        campaign.isPrePaidConsumer = isPrePaidConsumer;
        campaign.isPostPaidConsumer = isPostPaidConsumer;
        campaign.isPostPaidCorporate = isPostPaidCorporate;
        return campaign;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/object-factory.service.ts